<template>
  <div>
    <Header :title="'セミナー管理'" />
    <div
      class="boss-admin-container clearfix"
    >
      <sidebar />
      <keep-alive :include="whiteList">
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'
import { mapActions } from 'vuex'

export default {
  components: {
    Sidebar,
    Header
  },
  data () {
    return {
      whiteList: ['SeminarEntryTop']
    }
  },
  created () {
    this.storeMaster('seminarStatuses')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
